import { BaseException } from "@/exceptions/base-exception.exception"
import { ExceptionWeights } from "@/enums/exceptions/exception-weights"
import { Activity } from "@/models/activity.model"
import { type IActivity } from "@/interfaces/api/activity.interface"

export class CannotDeleteWorkPeriodWithLinkedActivitiesException extends BaseException {
  exceptionId = "CANNOT_DELETE_WORK_PERIOD_WITH_LINKED_ACTIVITIES"
  title = "Kan dienst niet verwijderen"
  weight = ExceptionWeights.ERROR

  private readonly linkedActivities: Activity[]

  constructor(linkedActivities: IActivity[]) {
    super()
    this.linkedActivities = linkedActivities.map((activity) => new Activity(activity))
  }

  public getMessage(): string {
    const activitiesMessage = this.linkedActivities
      .map(
        (activity) =>
          `- ${activity.getTypeString()} van ${activity.timeStart?.format("HH:mm")} uur tot ${activity.timeEnd?.format("HH:mm")} uur`
      )
      .join("\n")

    return `De dienst kan niet worden verwijderd omdat er activiteiten aan gekoppeld zijn:\n${activitiesMessage}`
  }
}
